import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Thu Aug 09 2018
 * @author PKl
 * @author LZe
 */
import * as React from 'react';
import { T } from '../../i18n/T';
import Icon, { IconType } from '../../media/Icon';
import AlertStyled from './styled/AlertStyled';
/**
 * Alert
 * @component
 * TODO: complete action functionality
 */

var Alert =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Alert, _React$PureComponent);

  function Alert(props) {
    var _this;

    _classCallCheck(this, Alert);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Alert).call(this, props));
    _this.copyDataToClipboard = _this.copyDataToClipboard.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Alert, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.onWillUnmount) {
        this.props.onWillUnmount();
      }
    }
  }, {
    key: "copyDataToClipboard",
    value: function copyDataToClipboard() {
      var el = document.createElement('textarea');
      el.value = JSON.stringify(this.props.copyData);
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return React.createElement(AlertStyled, {
        type: props.type,
        className: props.className
      }, props.title != null && React.createElement("div", {
        className: "alert-type"
      }, props.title, " ", props.count > 1 && React.createElement(React.Fragment, null, "(", props.count, ")")), React.createElement("div", {
        className: "alert-content"
      }, props.children), props.action != null && React.createElement("div", {
        className: "alert-action"
      }, React.createElement("a", {
        href: ""
      }, React.createElement(T, {
        id: "Recalculate"
      }))), props.copyData && React.createElement("div", {
        className: "alert-action"
      }, React.createElement("a", {
        onClick: this.copyDataToClipboard,
        className: "pointer fs-90"
      }, React.createElement(T, {
        id: "Copy"
      }))), props.onClose != null && React.createElement("div", {
        className: "alert-action alert-action-close",
        onClick: props.onClose
      }, React.createElement(Icon, {
        iconType: IconType.cancelO,
        iconHeight: 15
      })));
    }
  }]);

  return Alert;
}(React.PureComponent);

export { Alert as default };